class CartCounter {
    hideClassName = 'cart-counter--hide';
    elSelector = '.cart-counter';
    textElSelector = '.cart-counter__total';

    /**
     * @type {HTMLElement}
     */
    el;

    /**
     * @type {HTMLElement}
     */
    textEl;

    /**
     * @type {number}
     */
    _count;

    get count() {
        return this._count;
    }

    set count(value) {
        this._count = Number(value);
        this.onChange();
    }

    constructor() {
        this.el = document.querySelector(this.elSelector);

        if (!this.el) {
            return;
        }
        
        this.textEl = this.el.querySelector(this.textElSelector);

        if (!this.textEl) {
            return;
        }

        this.count = Number(this.textEl.textContent);

        window.cartCounter = this;
    }

    onChange() {
        this.textEl.textContent = this.count;

        if (this.count === 0) {
            this.el.classList.add(this.hideClassName);
        } else {
            this.el.classList.remove(this.hideClassName);
        }
    }
}   

(() => {
    new CartCounter();
})();
